import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MegaphoneStateFalseNofiFalseIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MegaphoneStateFalseNofiFalseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M10.4391 14.7397H6.4831C4.01098 14.7397 2 12.7329 2 10.2665C2 7.80018 4.01097 5.79337 6.4831 5.79337H10.4391C10.7307 5.79337 10.9667 6.0288 10.9667 6.31975V14.2133C10.9667 14.5043 10.7307 14.7397 10.4391 14.7397ZM6.4831 6.84612C4.5932 6.84612 3.05521 8.38001 3.05521 10.2665C3.05521 12.1531 4.5932 13.6869 6.4831 13.6869H9.91149V6.84611L6.4831 6.84612Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.3976 18.5333C20.2008 18.5333 20.0035 18.4973 19.8149 18.4243C19.7732 18.4079 19.7335 18.3863 19.6969 18.3596C19.6655 18.337 16.5292 16.0741 14.9809 15.4717C13.4501 14.8764 10.4463 14.7407 10.4164 14.7397C10.1341 14.7274 9.91148 14.495 9.91148 14.2133V6.31974C9.91148 6.02879 10.1475 5.79337 10.4391 5.79337C10.4649 5.79337 13.04 5.78411 14.782 5.13848C16.5467 4.48462 19.6618 2.19817 19.6933 2.17556C19.7309 2.1478 19.7716 2.12518 19.8149 2.10873C20.308 1.91751 20.8639 1.98125 21.3013 2.27836C21.7388 2.5765 22 3.06998 22 3.59842V16.9347C22 17.4631 21.7388 17.9566 21.3013 18.2547C21.0314 18.4387 20.7155 18.5333 20.3976 18.5333ZM20.2518 17.461C20.4079 17.5073 20.5708 17.4785 20.7063 17.386C20.8577 17.2821 20.9448 17.1177 20.9448 16.9347V3.59842C20.9448 3.41542 20.8577 3.25092 20.7063 3.14709C20.5707 3.05456 20.4095 3.02783 20.2534 3.07101C19.7706 3.42261 16.9244 5.46746 15.1499 6.12543C13.716 6.65695 11.8627 6.79677 10.9667 6.83276V13.7168C11.9348 13.7846 14.0612 13.9841 15.3642 14.4909C16.928 15.0995 19.7742 17.1187 20.2518 17.461Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.66565 22C7.39713 22 6.3651 20.9709 6.3651 19.7053V14.2133C6.3651 13.9224 6.60108 13.6869 6.89271 13.6869H10.4391C10.7307 13.6869 10.9667 13.9224 10.9667 14.2133V19.7053C10.9667 20.9709 9.93467 22 8.66565 22ZM7.42031 14.7397V19.7053C7.42031 20.39 7.97883 20.9473 8.66565 20.9473C9.35246 20.9473 9.91149 20.39 9.91149 19.7053V14.7397H7.42031Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default MegaphoneStateFalseNofiFalseIcon;
